export const styles = {
  listWrap: {
    padding: '24px',
  },
};
